import React from 'react';
import './AddSkillBtn.css';
import { FaPlus } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';

export const AddSkillBtn = (props) => {
  const { t } = useTranslation('library');

  return (
    <div
      className="div-block-475 add_skill"
      prop-events-names="onClick"
      prop-events-value-onclick="handleAddSkillBtnClick"
    >
      <FaPlus
        className={'image-152 add_sk'}
        color={'#FFFFFF'}
        style={{
          width: '14px',
          height: '14px',
        }}
      />
      <div className="text-block-284 add_skill_text">{t('Add Skill')}</div>
    </div>
  );
};
